import { useSelector, useDispatch } from 'react-redux'
import Dropdown from 'react-bootstrap/Dropdown'
import { fullBasePath } from "../../util/util"
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import Badge from 'react-bootstrap/Badge'
import NewMessageDropdown from '../NewMessageDropdown/NewMessageDropdown'
import {
	setShow as setShowMessageCenter,
	selectTotalNewMessageCount
} from '../MessageCenter/messageCenterSlice'
import {
	Link
} from "react-router-dom"
import {
	getChatRoom
} from '../MessageCenter/messageCenterSlice'

import classes from './TopNav.module.css'
import useBranding from '../../hooks/useBranding'
import Button from "react-bootstrap/Button";

const logout = {
	text: "Logout",
	href: '/logout',
}

const genericNavItems = []

const gymNavItems = [
	{
		text: "Profile",
		href: '/profile',
		isReactLink: true,
	}, {
		text: "Settings",
		href: '/settings',
		isReactLink: true,
	},{
		text: "Customization",
		href: '/customization-dashboard',
		ownerOnly:true,
		isReactLink: true,
	}, {
		text: "Upgrade",
		href: '/upgrade',
	},{
		text: "Refer & Earn",
		href: '/referrals',
		ownerOnly:true,
		isReactLink: true,
	}
]

const trainerNavItems = [
	{
		text: "Profile",
		href: '/profile',
		isReactLink: true,
	}, {
		text: "Settings",
		href: '/settings',
		isReactLink: true,
	}, {
		text: "Upgrade",
		href: '/upgrade',
	},{
		text: "Customization",
		href: '/customization-dashboard',
		ownerOnly:true,
		isReactLink: true,
	},{
		text: "Refer & Earn",
		href: '/referrals',
		ownerOnly:true,
		isReactLink: true,
	}
]

const clientNavItems = [
	{
		text: "Profile",
		href: '/profile',
		isReactLink: true
	}, {
		text: "Settings",
		href: '/settings',
		isReactLink: true
	}
]

const prospectNavItems = [
	{
		text: "Profile",
		href: '/profile',
		isReactLink: true
	}, {
		text: "Settings",
		href: '/settings',
		isReactLink: true
	}
]

const chainNavItems = [
	{
		text: "Profile",
		href: '/profile',
		isReactLink: true

	}, {
		text: "Settings",
		href: '/settings',
		isReactLink: true
	}, {
		text: "Upgrade",
		href: '/upgrade',
	}
]
const gymTrainerNavItems = [
	{
		text: "Profile",
		href: '/profile',
		isReactLink: true,
	}, {
		text: "Settings",
		href: '/settings',
		isReactLink: true,
	}
]

const gymLoggedInAsTrainerNavItems = [
	{
		text: "Gym Profile",
		href: '/profile',
		isReactLink: true,
	}, {
		text: "Gym Settings",
		href: '/settings',
		isReactLink: true,
	}
]

const accountTypeNavItems = {
	gym: gymNavItems,
	trainer: trainerNavItems,
	client: clientNavItems,
	prospect: prospectNavItems,
	chain: chainNavItems,
	gymTrainer: gymTrainerNavItems,
	gymAsTrainer: gymLoggedInAsTrainerNavItems,
}


const TopNav = props => {
	const dispatch = useDispatch()
	const user = useSelector(state => state.users.current_user)
	const isMAXUser = useSelector(
		state => Boolean(state.users.current_user.isMAXUser)
	)

	const totalNewMessageCount = useSelector(selectTotalNewMessageCount)
	const { account_type: accountType, profilePic } = user
	const customBranding = useBranding()

	const isGym = (useSelector(state => state.users.current_user.gym)) === '1' //is true if a gym or a gym logged in as trainer
	const isTrainer = (((useSelector(state => state.users.current_user.trainer)) === '1') && !isGym); // is only true if user is not logged in as a trainer thru a gym
	const isOwner = user?.is_owner === 1
	const isClient = user.account_type === 'client'
	let navItems;
	if (isTrainer && user.gym_id !== '0') {
		navItems = [
			...genericNavItems,
			...accountTypeNavItems["gymTrainer"],
			logout
		]
	} else if (user.gym_id !== '0' && user.account_type === "trainer" && !isTrainer) {
		navItems = [
			...genericNavItems,
			...accountTypeNavItems["gymAsTrainer"],
			logout
		]
	} else {
		navItems = [
			...genericNavItems,
			...accountTypeNavItems[accountType],
			logout
		]
	}
	//only show owner only links to owners
	navItems = navItems.filter(navItem=>Boolean(navItem.ownerOnly)?isOwner:true)

	//get map from user_id_number to the private chat room they are part of
	//used when toggling the chat
	const memberRoomMap = useSelector(state=>state.messageCenter.rooms.memberRoomMap)
	
	return (
		<Nav >
			{!(isMAXUser && isGym) && <button
				onClick={() => {
					const params = new URLSearchParams(window.location.search)
					const memberId = (
						isClient
						? user.trainer_data?.trainer_id
						: params.get('client') || params.get('clientId') || params.get('client_id')
					)
					const room_id = memberRoomMap[memberId]
					if (memberId!=='favorite'&&Boolean(memberId)) {
						dispatch(getChatRoom({room_id}))
					}
					dispatch(setShowMessageCenter(true))
				}}
				style={{
					height: '100%',
					background: 'transparent',
					color: customBranding ? customBranding.textColor : '#ccc',
					border: 'none',
					position: 'reltive'
				}}
				className={classes.showMessageCenterButton}
			>
				<i className="fas fa-comments" />
				{totalNewMessageCount > 0 &&
					<Badge>
						{totalNewMessageCount}
					</Badge>
				}
			</button>}
			<NavDropdown id={profilePic ? classes.ProfileMenuToggle : ''} title={
				profilePic ?
					<div style={{
						display: 'inline-block',
						width: '34px',
						height: '34px',
						borderRadius: '100%',
						overflow: 'hidden',
						flex: '0 0 auto',
						border: '2px solid #eee',
						marginRight: '30px'
					}}>
						<img style={{
							objectFit: 'cover',
							width: '100%',
							height: '100%'
						}} src={profilePic} alt="profile" />
					</div> :
					<span style={{
						color: customBranding ? customBranding.textColor : "#f8f9fa"
					}}>
						Account</span>
			}>
				{navItems.map(item => (
					item.isReactLink ? (
						<Link className="nav-link" key={item.text} to={item.href}>
							{item.href.includes('upgrade')
								? <span className="text-success">
									{item.text} <i className="fa fa-star ml-1"/>
								</span>
		 						: item.text
							}
							
						</Link>
					) : (
						<a key={item.text} className="nav-link" href={`${fullBasePath()}${item.href}`}>
							{item.href.includes('upgrade')
								? <span className="text-success">
									{item.text}
									<i className="fa fa-star ml-1"/>
								</span>
		 						: item.text
							}
						</a>
					)
				))}
			</NavDropdown>
		</Nav>
	)
}

export default TopNav